import type { Input } from '@builder.io/sdk';

const downloadFields = [
  {
    name: 'heading',
    type: 'string',
    helperText: 'Copy for the image',
  },
  {
    name: 'label',
    type: 'string',
  },
  {
    name: 'url',
    type: 'string',
  },
] as const satisfies DeepReadonly<Input[]>;

export type DownloadProps = GenerateBuilder<typeof downloadFields>;

const downloadBuilderConfig = {
  name: 'HCI Download Component',
  inputs: downloadFields,
};

export default downloadBuilderConfig;
